export enum EBloodGroup {
  A = 'A',
  APlus = 'A+',
  B = 'B',
  BPlus = 'B+',
  O = 'O',
  OPlus = 'O+',
  AB = 'AB',
  ABPlus = 'AB+'
}
